<template>
  <div>
    <AnalyticMenuTop />
    <b-row>
      <b-col
        lg="6"
        md="6"
      >
        <b-col cols="12">
          <Analytic30Day />
        </b-col>
        <b-col cols="12">
          <AnalyticMap />
        </b-col>
      </b-col>
      <b-col
        lg="6"
        md="6"
      >
        <AnalyticImage />
      </b-col>
    </b-row>
    <!-- <br> -->
    <AnalyticStatistics />
    <br>
    <AnalyticChartRightLane />
    <!-- <br> -->
    <!-- <br> -->
    <AnalyticTable />
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import AnalyticMap from '@/views/analytic120/total/AnalyticMap.vue'
import Analytic30Day from '@/views/analytic120/total/Analytic30Day.vue'
import AnalyticImage from '@/views/analytic120/total/AnalyticImage.vue'
import AnalyticStatistics from '@/views/analytic120/total/AnalyticStatistics.vue'
import AnalyticTable from '@/views/analytic120/total/AnalyticTable.vue'
import AnalyticMenuTop from '@/views/analytic120/total/AnalyticMenuTop.vue'
import AnalyticChartRightLane from '@/views/analytic120/total/AnalyticChart-RightLane.vue'
// import axios from '@axios'
export default {
  components: {
    BRow,
    BCol,
    AnalyticMap,
    Analytic30Day,
    AnalyticImage,
    AnalyticStatistics,
    AnalyticTable,
    AnalyticMenuTop,
    AnalyticChartRightLane,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

  <style>
  </style>
